const duration = [
  { label: "Less than 30 minutes", value: "1" },
  { label: "30 - 60 minutes", value: "2" },
  { label: "60 - 90 minutes", value: "3" },
  { label: "90 - 120 minutes", value: "4" },
  { label: "More than 120 minutes", value: "5" },
];

export default duration;